import type { Step } from "react-joyride";

export const templateByDepartmentTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຫນ້າຮ່າງເອກະສານຕາມພະແນກ! ຫນ້ານີ້ຊ່ວຍໃຫ້ທ່ານຄົ້ນຫາຮ່າງເອກະສານຕາມພະແນກທີ່ທ່ານສົນໃຈ. ທ່ານບໍ່ຈຳເປັນຕ້ອງຮູ້ຊື່ຮ່າງເອກະສານກ່ອນ. ທ່ານຈະໄດ້ຮຽນຮູ້ວິທີໃຊ້ງານຫນ້ານີ້ໃນບົດສອນສັ້ນໆນີ້.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="by-department-header"]',
    content:
      "ນີ້ແມ່ນສ່ວນ header ຂອງຫນ້າ. ທ່ານຈະເຫັນຫົວຂໍ້ ແລະ ຄຳອະທິບາຍກ່ຽວກັບຫນ້ານີ້. ຫນ້ານີ້ຈະສະແດງຮ່າງເອກະສານຈັດຕາມພະແນກເພື່ອໃຫ້ທ່ານຄົ້ນຫາໄດ້ງ່າຍຂຶ້ນ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="by-department-cards"]',
    content:
      "ນີ້ແມ່ນກາດພະແນກທັງໝົດ. ແຕ່ລະກາດຈະສະແດງຊື່ພະແນກ ແລະ ຈຳນວນຮ່າງເອກະສານທີ່ມີຢູ່. ທ່ານສາມາດກົດທີ່ກາດເພື່ອເບິ່ງລາຍລະອຽດເພີ່ມເຕີມ.",
    placement: "top",
  },
  {
    target: '[data-tourid="by-department-frequently-used"]',
    content:
      "ນີ້ແມ່ນພາກສ່ວນຮ່າງເອກະສານທີ່ມີໃນພະແນກ. ທ່ານສາມາດກົດທີ່ຮ່າງເອກະສານເພື່ອເບິ່ງລາຍລະອຽດ ຫຼື ດາວໂຫຼດ. ຖ້າຮ່າງເອກະສານມີດາວ (⭐), ມັນໝາຍຄວາມວ່າແນະນຳໃຫ້ໃຊ້.",
    placement: "top",
  },
  {
    target: '[data-tourid="by-department-view-all"]',
    content:
      "ນີ້ແມ່ນປຸ່ມ 'ເບິ່ງຮ່າງເອກະສານທັງໝົດ'. ຖ້າພະແນກມີຮ່າງເອກະສານຫຼາຍກວ່າທີ່ສະແດງໃນພາກສ່ວນຮ່າງທີ່ໃຊ້ບໍ່, ທ່ານສາມາດກົດປຸ່ມນີ້ເພື່ອເບິ່ງຮ່າງເອກະສານທັງໝົດຂອງພະແນກນີ້ໃນຫນ້າລາຍການຫຼັກ.",
    placement: "top",
  },
];
